export default __webpack_public_path__ + "locales/pt-BR/UploadPanel.json?hash=437dab9685b97678c509d3455f9ec7a9";